import arrays from './arrays';
import date from './date';
import strings from './strings';
import utils from './utils';
import numbers from './numbers';

export default { ...date, ...arrays, ...strings, ...utils, ...numbers };
